import { address } from './address';
import { alias } from './alias';
import { app } from './app';
import { branch } from './branch';
import { challenge } from './challenge';
import { citizenship } from './citizenship';
import { collection } from './collection';
import { comments } from './comments';
import { consent } from './consent';
import { countries } from './countries';
import { country } from './country';
// import { currency } from './currency'
// import { date } from './date'
import { error } from './error';
import { financial } from './financial';
import { foreign } from './foreign';
import { foreignBornDocuments } from './foreignborndocuments';
import { pvqForeignBornDocumentsCivil } from './pvqForeignborndocumentscivil';
import { formChoices } from './formchoices';
import { help } from './help';
import { history } from './history';
import { identification } from './identification';
import { intro } from './intro';
import { introduction } from './introduction';
import { legal } from './legal';
import { login } from './login';
import { logout } from './logout';
import { military } from './military';
import { name } from './name';
import { application } from './application';
import { psychological } from './psychological';
import { reference } from './reference';
import { relationships } from './relationships';
import {
  releases, releasesPvq, releasesSF85, releasesSF85P, releasesSF85PS
} from './releases';
import { review } from './review';
import { saved } from './saved';
import { scorecard } from './scorecard';
import { section } from './section';
import { signature } from './signature';
import { spinner } from './spinner';
import { substance } from './substance';
import { suggestions } from './suggestions';
import { survey } from './survey';
import { telephone } from './telephone';
import { email } from './email';
import { temp } from './temp';

const en = {
  // Application
  app,
  consent,
  error,
  help,
  intro,
  introduction,
  login,
  logout,
  review,
  saved,
  scorecard,
  section,

  // Components
  address,
  alias,
  branch,
  collection,
  comments,
  country,
  // currency,
  // date,
  foreignBornDocuments,
  pvqForeignBornDocumentsCivil,
  name,
  reference,
  releases,
  releasesPvq,
  releasesSF85,
  releasesSF85P,
  releasesSF85PS,
  signature,
  spinner,
  suggestions,
  survey,
  telephone,
  email,

  // Sections
  identification,
  financial,
  citizenship,
  relationships,
  military,
  history,
  foreign,
  legal,
  substance,
  psychological,
  application,

  // Misc
  challenge,
  countries,
  formChoices,
  temp,
};

export default en;

//  LocalWords:  citizenships
